var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokenLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5937_29934",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 2.08329H17.9166V17.9166H2.08325V2.08329Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5937_29934)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43915 15.9833C6.49479 16.9277 4.96367 16.9277 4.01928 15.9833C3.07491 15.0389 3.07491 13.5077 4.01928 12.5634L6.59097 9.99169C6.83018 9.75248 6.83018 9.36465 6.59097 9.12544C6.35176 8.88623 5.96392 8.88623 5.72472 9.12544L3.15302 11.6971C1.73024 13.1199 1.73024 15.4267 3.15302 16.8495C4.57583 18.2723 6.88262 18.2723 8.30541 16.8495C8.30541 16.8495 8.30541 16.8495 8.30541 16.8495L10.8771 14.2778C11.1163 14.0386 11.1163 13.6508 10.8771 13.4116C10.6379 13.1724 10.2501 13.1724 10.0108 13.4116L7.43916 15.9833L7.43915 15.9833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4116 10.8744C13.6508 11.1136 14.0386 11.1136 14.2778 10.8744L16.8495 8.30273C18.2723 6.87995 18.2723 4.57313 16.8495 3.15035C15.4267 1.72754 13.1199 1.72753 11.6971 3.15035C11.6971 3.15035 11.6971 3.15035 11.6971 3.15036L9.12545 5.72204C8.88624 5.96125 8.88624 6.34908 9.12545 6.58829C9.36466 6.8275 9.75249 6.8275 9.9917 6.58829L12.5634 4.0166L12.5634 4.0166C13.5078 3.07221 15.0389 3.07221 15.9833 4.0166C16.9276 4.96097 16.9276 6.49212 15.9833 7.43648L13.4116 10.0082C13.1724 10.2474 13.1724 10.6352 13.4116 10.8744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65745 5.65751C5.89666 5.4183 5.89666 5.03046 5.65745 4.79126L4.37159 3.50539C4.13238 3.26619 3.74454 3.26619 3.50533 3.50539C3.26613 3.7446 3.26613 4.13244 3.50533 4.37165L4.7912 5.65751C5.0304 5.89672 5.41824 5.89672 5.65745 5.65751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65745 5.65751C5.89666 5.4183 5.89666 5.03046 5.65745 4.79126L4.37159 3.50539C4.13238 3.26619 3.74454 3.26619 3.50533 3.50539C3.26613 3.7446 3.26613 4.13244 3.50533 4.37165L4.7912 5.65751C5.0304 5.89672 5.41824 5.89672 5.65745 5.65751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08325 6.93886C2.08325 7.27715 2.35749 7.55139 2.69578 7.55139H4.51424C4.85253 7.55139 5.12677 7.27715 5.12677 6.93886C5.12677 6.60057 4.85253 6.32633 4.51424 6.32633H2.69578C2.35749 6.32633 2.08325 6.60057 2.08325 6.93886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08325 6.93886C2.08325 7.27715 2.35749 7.55139 2.69578 7.55139H4.51424C4.85253 7.55139 5.12677 7.27715 5.12677 6.93886C5.12677 6.60057 4.85253 6.32633 4.51424 6.32633H2.69578C2.35749 6.32633 2.08325 6.60057 2.08325 6.93886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93895 5.12683C7.27724 5.12683 7.55148 4.85259 7.55148 4.5143V2.69584C7.55148 2.35755 7.27724 2.08331 6.93895 2.08331C6.60066 2.08331 6.32642 2.35755 6.32642 2.69584V4.5143C6.32642 4.85259 6.60066 5.12683 6.93895 5.12683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93895 5.12683C7.27724 5.12683 7.55148 4.85259 7.55148 4.5143V2.69584C7.55148 2.35755 7.27724 2.08331 6.93895 2.08331C6.60066 2.08331 6.32642 2.35755 6.32642 2.69584V4.5143C6.32642 4.85259 6.60066 5.12683 6.93895 5.12683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4944 16.4944C16.7336 16.2552 16.7336 15.8674 16.4944 15.6282L15.2085 14.3423C14.9693 14.1031 14.5815 14.1031 14.3422 14.3423C14.103 14.5815 14.103 14.9694 14.3422 15.2086L15.6281 16.4944C15.8673 16.7336 16.2552 16.7336 16.4944 16.4944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4944 16.4944C16.7336 16.2552 16.7336 15.8674 16.4944 15.6282L15.2085 14.3423C14.9693 14.1031 14.5815 14.1031 14.3422 14.3423C14.103 14.5815 14.103 14.9694 14.3422 15.2086L15.6281 16.4944C15.8673 16.7336 16.2552 16.7336 16.4944 16.4944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.061 17.9166C13.3993 17.9166 13.6736 17.6424 13.6736 17.3041V15.4856C13.6736 15.1473 13.3993 14.8731 13.061 14.8731C12.7227 14.8731 12.4485 15.1473 12.4485 15.4856V17.3041C12.4485 17.6424 12.7227 17.9166 13.061 17.9166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.061 17.9166C13.3993 17.9166 13.6736 17.6424 13.6736 17.3041V15.4856C13.6736 15.1473 13.3993 14.8731 13.061 14.8731C12.7227 14.8731 12.4485 15.1473 12.4485 15.4856V17.3041C12.4485 17.6424 12.7227 17.9166 13.061 17.9166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.873 13.0611C14.873 13.3993 15.1473 13.6736 15.4856 13.6736H17.304C17.6423 13.6736 17.9166 13.3993 17.9166 13.0611C17.9166 12.7228 17.6423 12.4485 17.304 12.4485H15.4856C15.1473 12.4485 14.873 12.7228 14.873 13.0611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.873 13.0611C14.873 13.3993 15.1473 13.6736 15.4856 13.6736H17.304C17.6423 13.6736 17.9166 13.3993 17.9166 13.0611C17.9166 12.7228 17.6423 12.4485 17.304 12.4485H15.4856C15.1473 12.4485 14.873 12.7228 14.873 13.0611Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLink);
export default __webpack_public_path__ + "static/media/broken-link.563aeee43eb1756a8be8d9458f862bad.svg";
export { ForwardRef as ReactComponent };